import { render } from "./PlansFood.vue?vue&type=template&id=bc424c3e"
import script from "./PlansFood.vue?vue&type=script&lang=js"
export * from "./PlansFood.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rizki\\OneDrive - OneDrive\\Documents\\UPI\\SEMESTER_5\\Kualitas Perangkat Lunak\\project-cephat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__